import React from 'react'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'

interface SvvFormControlProps {
  label: string
  htmlFor: string
  control: React.ReactNode
}

const SvvFormControl = ({
  label,
  control,
  htmlFor,
  ...rest
}: SvvFormControlProps): JSX.Element => {
  return (
    <FormControl
      variant="standard"
      {...rest}
      fullWidth={true}
      component={'fieldset'}
      sx={{ mb: 1.5 }}
    >
      <FormLabel
        component="label"
        htmlFor={htmlFor}
        sx={{ color: 'text.primary', mb: 0.7, fontSize: 16 }}
      >
        {label}
      </FormLabel>
      {control}
    </FormControl>
  )
}

export default SvvFormControl
